import { render } from "./DashboardOfferGallery.vue?vue&type=template&id=7dd88762&scoped=true"
import script from "./DashboardOfferGallery.vue?vue&type=script&lang=ts"
export * from "./DashboardOfferGallery.vue?vue&type=script&lang=ts"

import "./DashboardOfferGallery.vue?vue&type=style&index=0&id=7dd88762&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7dd88762"

export default script